import { ColumnsType } from 'antd/es/table/Table';
import { Routes } from 'config/routes';
import { DonationOutput, DonationListSort } from 'gql/types';
import { Link } from 'modules/common/components';
import LocaleDate from 'modules/common/components/LocaleDate';
import OutcomeCell from 'modules/donations/components/OutcomeCell';
import { getTranslation } from 'utils/getTranslation';

import { DonationCommentCell } from '../DonorDonationCommentCell';

const t = getTranslation('donor.DonorDonationsTable');

type Props = {
  productCategories?: Record<number, string>;
};

export const getColumns = ({
  productCategories,
}: Props): ColumnsType<DonationOutput> => [
  {
    title: t('donationId'),
    render: ({ shortId }: DonationOutput) => (
      <Link to={`${Routes.Donations}/${shortId}`}>{shortId}</Link>
    ),
    align: 'center',
  },
  {
    title: t('date'),
    key: DonationListSort.LastDonationDate,
    sorter: true,
    render: (row: DonationOutput) => (
      <LocaleDate dateValue={row.donationDate} />
    ),
    align: 'center',
  },
  {
    title: t('location'),
    render: (row: DonationOutput) => row.donor.location,
    align: 'center',
  },
  {
    title: t('comments'),
    render: (row: DonationOutput) => (
      <DonationCommentCell donation={row} variant="table" />
    ),
    align: 'center',
  },
  {
    title: t('products'),
    align: 'center',
    render: (row: DonationOutput) => {
      const isCellFilled = Boolean(row.products?.length) || row.ineligible;
      return (
        <>
          {isCellFilled ? (
            <OutcomeCell donation={row} productCategories={productCategories} />
          ) : (
            '-'
          )}
        </>
      );
    },
  },
];
